import { SUCCESS_STATUS } from "constants/http-status-code";
import { QueryResultType } from "./types";

/**
 * `Check if http response is success`
 * @param {QueryResultType<T>} res response to check
 * @returns {boolean}  return true if result is success
 */
export const isSuccess = <T>(res: QueryResultType<T>): boolean => {
  return SUCCESS_STATUS.includes(res?.results?.code);
};
